export const qtDetailModel = (id) => ({
    id: id,
    dtId: null,
    docId: null,
    line: null,
    itemId: null,
    itemCode: null,
    itemName: null,
    itemQty: null,
    itemUnit: null,
    itemPriceUnit: null,
    itemDiscount: null,
    itemDisType: null,
    itemTotal: null,
    itemStatus: null,
    whId: null,
    zoneId: null,
    ltId: null,
    dsSeq: null
});